export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatShortDate(dateString: string): string {
  return new Date(dateString).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function getSimilarityColor(
  similarity: number
): "green" | "yellow" | "orange" | "red" {
  if (similarity >= 0.8) return "green";
  if (similarity >= 0.6) return "yellow";
  if (similarity >= 0.4) return "orange";
  return "red";
}

const ACTION_MESSAGE_PATTERNS = [
  /^--feedback--$/i,
  /^--reset conversation--$/i,
  /^--reset converesation--$/i,
];

export function isActionMessage(comment: string): boolean {
  const trimmed = comment.trim();
  return ACTION_MESSAGE_PATTERNS.some((pattern) => pattern.test(trimmed));
}

export function filterActionMessages<T extends { comment: string }>(
  comments: T[]
): T[] {
  return comments.filter((c) => !isActionMessage(c.comment));
}

